export default __webpack_public_path__ + "static/media/icon-pickup.aa6d7b29.svg";